import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TProfile, TUserTelegram } from "../../types";

type UserState = {
  userTelegram: TUserTelegram | null;
  profile: TProfile | null;
  isAuthChecked: boolean;
  isAuthLoading: boolean;
};

const initialState: UserState = {
  userTelegram: null,
  profile: null,
  isAuthChecked: false,
  isAuthLoading: true,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<{
      userTelegram: TUserTelegram;      
    }>) {
      state.userTelegram = action.payload.userTelegram;      
      state.isAuthChecked = true;
      state.isAuthLoading = false;
    },

    setProfile(state, action: PayloadAction<any>) {
      state.profile = action.payload;
    },

    logout(state) {
      state.userTelegram = null;
      state.profile = null;
      state.isAuthChecked = true;
      state.isAuthLoading = false;
    },
  },
});

export const { setUser, setProfile, logout } = userSlice.actions;
export default userSlice.reducer;
